module.exports = __webpack_public_path__ + "img/404-desktop.4b8199d.svg";